import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";
import { Translate } from "react-localize-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { writeWarn } from "./logger";

import ErrorIcon from "../../img/icons/BBiconsErrorNotice";
import WarningIcon from "../../img/icons/BBiconsWarningNotice";
import SuccessIcon from "../../img/icons/BBiconsSuccesNotice";
import InfoIcon from "../../img/icons/BBiconsInfoNotice";

import "./message.scss";

class Message extends React.Component {
    render() {
        const Icon = this.getIcon(this.props.type);

        return (
            <div className={classnames(`bb-message is-${this.props.type}`, { 'shadowed': this.props.shadowed })} style={this.props.style}>
                <div className="left">
                    {Icon}
                </div>
                <div className="right">
                    <div className="message-title" style={{ display: "block" }}><b>{this.getTitle(this.props.type)}</b></div>
                    {(this.props.options && this.props.options.renderInnerHtml)
                        ? <div style={{ display: "block" }}>{ReactHtmlParser(this.props.message)}</div>
                        : <div style={{ display: "block" }}>{this.props.message}</div>}
                    {this.props.children}
                </div>
            </div>
        )
    }

    getTitle = type => {
        switch (type) {
            case 'error': return (<Translate id='Common.Error' />);
            case 'warning': return (<Translate id='Common.Warning' />);
            case 'success': return (<Translate id='Common.Success' />);
            case 'info': return (<Translate id='Common.Information' />);
            case 'processing': return (<Translate id='Common.Processing.Title' />);
            default: {
                writeWarn(`Unrecorgnized type value '${type}'`);
                return (<Translate id='Common.Warning' />);
            }
        }
    }

    getIcon = type => {
        switch (type) {
            case 'error': return <ErrorIcon />;
            case 'warning': return <WarningIcon />;
            case 'success': return <SuccessIcon />;
            case 'info': return <InfoIcon />;
            case 'processing': return <FontAwesomeIcon icon='cog' size='3x' spin={true} />
            default: {
                writeWarn(`Unrecorgnized type value '${type}'`);
                return WarningIcon;
            }
        }
    }
}

Message.propTypes = {
    type: PropTypes.oneOf(['error', 'warning', 'success', 'info', 'processing']),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default Message;